<template>
  <div class="user">
    <page-header :title="user.name" icon="user" v-if="!loading">
      <div slot="sub-title">
        {{ user.email }}
      </div>
      <div slot="controls" class="margin-left" v-if="$root.isSystem">
        <el-button type="primary" icon="el-icon-setting" @click="showDialog = true" plain>Update saldo</el-button>
        <saldo :saldo="saldo" />
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding mobile-padding flex-grid">
      <el-col :md="24" :lg="16" style="order: 2;">
        <el-card class="fty-padding">
          <h1 class="title">User transactions</h1>
          <transactions :api="transactionEndpoint" :newlyAddedTransaction="newTransaction" />
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="8" style="order: 1;">
        <el-card class="no-padding">
          <user-details :user="user" @edit="showEditUserDialog = true"  v-if="!loading"/>
        </el-card>
        <el-card class="no-padding nfc-card" v-if="$root.isSystem && !loading">
          <nfc-tags :userId="user.id" />
        </el-card>
      </el-col>
    </el-row>
  
    <el-dialog :append-to-body="true" width="600px" custom-class="dialog-no-padding" :show-close="false" :visible.sync="showDialog">
      <update-saldo-form v-if="showDialog" @created="handleCreatedTransaction" @close="showDialog = false" />
    </el-dialog>

    <el-dialog :append-to-body="true" width="400px" title="Add user" :visible.sync="showEditUserDialog">
      <upsert-form v-if="showEditUserDialog" :user="user" @update="update" />
    </el-dialog>

  </div>
</template>

<script>
import UserDetails from './UserDetails'
import Saldo from '@/components/shared/SaldoValue'
import UpdateSaldoForm from './UpdateSaldoForm'
import Transactions from '@/components/dashboard/transactions/Transactions'
import UpsertForm from './../UpsertForm'
import NfcTags from './nfc-tags/NfcTags'

export default {
  name: 'User',
  components: { UserDetails, Saldo, UpdateSaldoForm, Transactions, UpsertForm, NfcTags },
  data () {
    return {
      user: {},
      transactionEndpoint: '',
      newTransaction: null,
      loading: true,
      showDialog: false,
      showEditUserDialog: false
    }
  },
  computed: {
    saldo () {
      let decimalSplit = this.user.saldo.toString().split('.')
      return {
        base: decimalSplit[0],
        decimal: decimalSplit[1] !== undefined ? decimalSplit[1] : '00',
        currency: this.user.currency.name
      }
    }
  },
  methods: {
    handleCreatedTransaction (transaction) {
      this.showDialog = false
      this.newTransaction = transaction
      if (transaction.hasOwnProperty('station')) {
        this.user.saldo -= transaction.amount
      } else {
        this.user.saldo += transaction.amount
      }
    },
    async getUser () {
      const response = await this.$http.get(this.$api.users.get(this.$route.params.id))
      this.user = response.data
      this.loading = false
    },
    update (data) {
      this.showEditUserDialog = false
      for (let key in data) {
        this.user[key] = data[key]
      }
    },
    getTransactionsEndpoint () {
      const userId = this.$route.params.id
      if (this.$route.params.hasOwnProperty('orgId')) {
        const organizationId = this.$route.params.orgId
        this.transactionEndpoint = this.$api.organizations.users.transactions(organizationId, userId)
      } else {
        this.transactionEndpoint = this.$api.users.transactions(userId)
      }
    }
  },
  created () {
    this.getUser()
    this.getTransactionsEndpoint()
  }
}
</script>

<style lang="scss" scoped>
  .margin-left {
    > * {
      margin-left: 20px;
    }
  }

  .nfc-card {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/User.vue